import { render, staticRenderFns } from "./CarConfirmation.vue?vue&type=template&id=b272a70c&"
import script from "./CarConfirmation.vue?vue&type=script&lang=js&"
export * from "./CarConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports